import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { FetchProductsRequestTypes } from '../actions/ProductsActions';
import { makeRequestStatusSelector } from './RequestStatusSelectors';
import { getBillingNameKey, getCrmSuiteProductLevelForSkuIds, getCurrentProductVersion, getCurrentSkuIdForProduct, getLowestPaidProductLevel, getLowestPaidProductLevelFromList, getMaxProductVersionQuantity, getProduct, getProductForSkuId, getProductVersion, getSkuIdIsAddonOrService, getSkuIdIsHub, getSkuIdIsInCrmSuite, getSkuIdsContainOnlyCRMSuite, getQuantityPackForProductVersion, getSkuIdForFreeProduct, getIsSalesOrServiceProOrEntSku, getIncludedCoreSeatsQuantityForProductVersion, getSkuIdIsQuantityPack, getHighestProductLevelFromSkuIds, getIsCoreSeatSku, getCoreSeatSkuForProductLevel, getQuantifiableSkusForProductLine, getIncludedCoreSeatsQuantityForSuiteProductLevel, getIsPaidCoreSeatSku, isQuantityUpgrade, getHighestProductLevelSkuIdsByProductLine, isQuantifiableHub } from 'pricing-pages-lib/utils/productsUtils';
import { skuMapSelector, transformState } from './SelectorUtils';
import { getEmailSendsLimitMultiplier } from 'pricing-pages-lib/utils/contactsUtils';
import { getUpgradeProduct } from 'pricing-pages-lib/utils/upgradeProductUtils';
import { getMerchCardsToShow } from 'pricing-pages-ui/constants/merchCards/MerchCardsToShow';
import { PRODUCT_HUBSPOT_FREE } from 'self-service-api/constants/ProductIds';
export const fetchProductsStatus = makeRequestStatusSelector(FetchProductsRequestTypes.REQUEST);
export const parcelNameToProductIdSelector = ({
  abstractedProducts: {
    parcelNameToProductId
  }
}) => parcelNameToProductId;
export const skuSelector = (state, {
  skuId
}) => {
  const skuMap = skuMapSelector(state);
  return skuMap[skuId];
};
export const productSelector = createSelectorFromUtil(getProduct, transformState);
export const productVersionSelector = createSelectorFromUtil(getProductVersion, transformState);
export const productForSkuIdSelector = createSelectorFromUtil(getProductForSkuId, transformState);
export const currentSkuIdForProductSelector = createSelectorFromUtil(getCurrentSkuIdForProduct, transformState);
export const skuIdForFreeProductSelector = createSelectorFromUtil(getSkuIdForFreeProduct, transformState);
export const skuIdIsHubSelector = createSelectorFromUtil(getSkuIdIsHub, transformState);
export const crmSuiteProductLevelSelector = createSelectorFromUtil(getCrmSuiteProductLevelForSkuIds, transformState);
export const skuIdIsPartOfCrmSuiteSelector = createSelectorFromUtil(getSkuIdIsInCrmSuite, transformState);
export const skuIdsContainOnlyCrmSuite = createSelectorFromUtil(getSkuIdsContainOnlyCRMSuite, transformState);
export const billingNameKeySelector = createSelectorFromUtil(getBillingNameKey, transformState);
export const quantityPackForProductVersionSelector = createSelectorFromUtil(getQuantityPackForProductVersion, transformState);
export const includedCoreSeatsQuantityForProductVersionSelector = createSelectorFromUtil(getIncludedCoreSeatsQuantityForProductVersion, transformState);
export const includedCoreSeatsQuantityForSuiteProductLevelSelector = createSelectorFromUtil(getIncludedCoreSeatsQuantityForSuiteProductLevel, transformState);
export const skuIdIsAddonOrServiceSelector = createSelectorFromUtil(getSkuIdIsAddonOrService, transformState);
export const currentProductVersionSelector = createSelectorFromUtil(getCurrentProductVersion, transformState);
export const maxProductVersionQuantitySelector = createSelectorFromUtil(getMaxProductVersionQuantity, transformState);
export const emailSendsLimitMultiplierSelector = createSelectorFromUtil(getEmailSendsLimitMultiplier, transformState);
export const lowestPaidProductLevelSelector = createSelectorFromUtil(getLowestPaidProductLevel, transformState);
export const lowestPaidProductLevelFromListSelector = createSelectorFromUtil(getLowestPaidProductLevelFromList, transformState);
export const upgradeProductSelector = createSelectorFromUtil(getUpgradeProduct, transformState);
export const highlightedSkuIdsSelector = (state, {
  productLine,
  selectedTab,
  includeFree
}) => {
  const merchCardsToShow = getMerchCardsToShow({
    tab: selectedTab
  });
  const paidSkuIds = merchCardsToShow.map(productLevel => currentSkuIdForProductSelector(state, {
    productLine,
    productLevel
  }));

  if (includeFree) {
    return [currentSkuIdForProductSelector(state, {
      productId: PRODUCT_HUBSPOT_FREE
    }), ...paidSkuIds];
  }

  return paidSkuIds;
};
export const allProductVersionsSelector = ({
  abstractedProducts: {
    productVersions
  }
}) => productVersions || {};
/**
 * Selects the product map in a format that is used in ui-addon-upgrades and self-service-api
 */

export const rawProductListSelector = ({
  abstractedProducts: {
    rawProductList
  }
}) => rawProductList;
export const skuIdIsQuantityPackSelector = createSelectorFromUtil(getSkuIdIsQuantityPack, transformState);
export const isSalesOrServiceProOrEntSkuSelector = createSelectorFromUtil(getIsSalesOrServiceProOrEntSku, transformState);
export const getQuantifiableSkusForProductLineSelector = createSelectorFromUtil(getQuantifiableSkusForProductLine, transformState);
export const highestProductLevelFromSkuIdsSelector = createSelectorFromUtil(getHighestProductLevelFromSkuIds, transformState);
export const isCoreSeatSkuSelector = createSelectorFromUtil(getIsCoreSeatSku, transformState);
export const isPaidCoreSeatSkuSelector = createSelectorFromUtil(getIsPaidCoreSeatSku, transformState);
export const coreSeatSkuForProductLevelSelector = createSelectorFromUtil(getCoreSeatSkuForProductLevel, transformState);
export const isQuantityUpgradeSelector = createSelectorFromUtil(isQuantityUpgrade, transformState);
export const highestProductLevelSkuIdsByProductLineSelector = createSelectorFromUtil(getHighestProductLevelSkuIdsByProductLine, transformState);
export const isQuantifiableHubSelector = createSelectorFromUtil(isQuantifiableHub, transformState);